import React from 'react';
import { Portal } from 'react-portal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import swal from 'sweetalert';
import { getFundRequest } from './actions';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';


class ModalUpdateFR extends React.Component {
    constructor() {
        super();
        this.state = {
            fundRequest: {},
        };
        this.getFundRequest = getFundRequest.bind(this);
        this.save = this.save.bind(this);
        this.changeForm = this.changeForm.bind(this);
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== '' && nextProps.visible) this.getFundRequest(nextProps.id);
    }

    async save() {
        if (this.state.loading) return;
        this.setState({ loading: true });
        const { fundRequest } = this.state;
        try {
            const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Fund_Request__c`, {
                mode: 'cors',
                cache: 'no-cache',
                method: 'PATCH',
                body: JSON.stringify({
                    Id: fundRequest.Id,
                    Projected_No_of_Pri_Benes__c: fundRequest.Projected_No_of_Pri_Benes__c,
                    Total_Pri_Receipts__c: fundRequest.Total_Pri_Receipts__c,
                    Projected_No_of_Secondary_Benes__c: fundRequest.Projected_No_of_Secondary_Benes__c,
                    Total_Sec_Receipts__c: fundRequest.Total_Sec_Receipts__c,
                    Projected_No_of_Post_Sec_Benes__c: fundRequest.Projected_No_of_Post_Sec_Benes__c,
                    Total_Post_Sec_Receipts__c: fundRequest.Total_Post_Sec_Receipts__c,
                }),
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                    'Content-Type': 'application/json',
                },
            }).then((response) => {
                if (response.status !== 200) throw (new Error(response.message));
                return response.json();
            });
            this.setState({ loading: false });
            this.props.hideModal();
            this.props.afterSaveCallback();
            swal({
                text: result.message,
                title: 'Fund Request status updated successfully.',
            });
        } catch (error) {
            swal({
                text: error.toString(),
                title: 'An error occured when updating status',
            });
            this.setState({ loading: true });
        }
    }

    changeForm(attributeName, value) {
        // These states only accepts numeric values
        const numericValueAttributes = [
            'Projected_No_of_Pri_Benes__c',
            'Total_Pri_Receipts__c',
            'Projected_No_of_Secondary_Benes__c',
            'Total_Sec_Receipts__c',
            'Projected_No_of_Post_Sec_Benes__c',
            'Total_Post_Sec_Receipts__c',
        ];

        const nonNumericPattern = /[^0-9.]/g;

        if (numericValueAttributes.includes(attributeName)) {
            // Test the value
            if (!nonNumericPattern.test(value)) {
                this.setState({
                    fundRequest: {
                        ...this.state.fundRequest,
                        [attributeName]: value,
                    },
                });
            }
        }
    }

    render() {
        const { fundRequest } = this.state;
        return (
            <Portal>
                <div className="modal modal-backdrop" tabIndex="-2" role="dialog" style={{ display: this.props.visible ? 'block' : 'none' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ showModal: false })}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 className="modal-title">Update Fund Request</h4>
                            </div>
                            <div className="modal-body">
                                <p style={{ textAlign: 'center' }}>
                                    {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                                </p>
                                <div className="form-group">
                                    <label>Projected No. Of Pri Benes</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={fundRequest.Projected_No_of_Pri_Benes__c}
                                        onChange={e => this.changeForm('Projected_No_of_Pri_Benes__c', e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Total Pri Receipts</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={fundRequest.Total_Pri_Receipts__c}
                                        onChange={e => this.changeForm('Total_Pri_Receipts__c', e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Projected No. of Sec Benes</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={fundRequest.Projected_No_of_Secondary_Benes__c}
                                        onChange={e => this.changeForm('Projected_No_of_Secondary_Benes__c', e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Total Sec Receipts</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={fundRequest.Total_Sec_Receipts__c}
                                        onChange={e => this.changeForm('Total_Sec_Receipts__c', e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Projected No. of Post Sec Benes</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={fundRequest.Projected_No_of_Post_Sec_Benes__c}
                                        onChange={e => this.changeForm('Projected_No_of_Post_Sec_Benes__c', e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Total Post Sec Receipts</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={fundRequest.Total_Post_Sec_Receipts__c}
                                        onChange={e => this.changeForm('Total_Post_Sec_Receipts__c', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    onClick={() => this.props.hideModal()}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    onClick={this.save}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>
        );
    }
}

ModalUpdateFR.propTypes = {
    id: PropTypes.string,
    hideModal: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    afterSaveCallback: PropTypes.func,
    visible: PropTypes.bool,
};

ModalUpdateFR.defaultProps = {
    id: '',
    afterSaveCallback: () => null,
    visible: false,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(ModalUpdateFR);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/FundRequest/ModalUpdateFR.js
// module id = 471
// module chunks = 0